import { Routes } from '@angular/router';
import { FunctionAuthorisedGuard } from '@fleet/auth/guards/function-authorised.guard';
import { JobGuard } from '@fleet/job/guards/job.guard';
import { LayoutComponent } from '@fleet/layout/layout/layout.component';

import { TravellerAuthGuard } from './guards/traveller-auth.guard';
const jobRoutes = [
  {
    path: 'not-authorised',
    loadChildren: () =>
      import('@fleet/authorisation/authorisation.module').then(
        (m) => m.AuthorisationModule
      ),
  },

  {
    path: 'job/not-authorised',
    loadChildren: () =>
      import('@fleet/authorisation').then((m) => m.AuthorisationModule),
  },
  {
    path: 'job/edit/:jobId',
    data: {
      title: 'Jobs',
      functions: ['TRAVELLER_JOB_SEARCH:read'],
    },
    canActivate: [FunctionAuthorisedGuard],
    loadChildren: () =>
      import('@fleet/job/job-create/job-create.module').then(
        (m) => m.JobCreateModule
      ),
  },
  {
    path: 'job/upcoming',
    data: {
      title: 'Jobs',
      functions: ['TRAVELLER_JOB_SEARCH:read'],
      nonAuthorisedRedirect: '/not-authorised',
    },
    canActivate: [FunctionAuthorisedGuard],
    loadChildren: () =>
      import(
        '@fleet/traveller/traveller-upcoming-jobs/traveller-upcoming-jobs.module'
      ).then((m) => m.TravellerUpcomingJobsModule),
  },
  {
    path: 'job/history',
    data: {
      title: 'Jobs',
      functions: ['TRAVELLER_JOB_SEARCH:read'],
      nonAuthorisedRedirect: '/not-authorised',
    },
    canActivate: [FunctionAuthorisedGuard],
    loadChildren: () =>
      import(
        '@fleet/traveller/traveller-past-jobs/traveller-past-jobs.module'
      ).then((m) => m.TravellerPastJobsModule),
  },
  {
    path: 'job/:jobId',
    canActivate: [JobGuard],
    loadChildren: () =>
      import('@fleet/job/job-detail/job-detail.module').then(
        (m) => m.JobDetailModule
      ),
  },
  {
    path: 'settings/not-authorised',
    loadChildren: () =>
      import('@fleet/authorisation').then((m) => m.AuthorisationModule),
  },
  {
    path: 'settings',
    data: {
      functions: ['TRAVELLER_SETTINGS:read'],
      nonAuthorisedRedirect: '/not-authorised',
    },
    canActivate: [FunctionAuthorisedGuard],
    loadChildren: () =>
      import(
        '@fleet/traveller/traveller-settings/traveller-settings.module'
      ).then((m) => m.TravellerSettingsModule),
  },
];
export const travellerAppRoutes: Routes = [
  { path: '', redirectTo: 'traveller/job/new', pathMatch: 'full' },
  {
    path: 'not-authorised',
    loadChildren: () =>
      import('@fleet/authorisation').then((m) => m.AuthorisationModule),
  },
  {
    path: 'auth',
    component: LayoutComponent,
    data: { layout: 'empty' },
    loadChildren: () =>
      import('@fleet/auth/auth.module').then((m) => m.AuthModule),
  },

  {
    path: 'link/:token',
    component: LayoutComponent,
    data: { layout: 'empty' },
    loadChildren: () =>
      import('./job-link/job-link.module').then((m) => m.JobLinkModule),
  },
  {
    path: 'guest',
    component: LayoutComponent,
    data: { layout: 'traveller' },
    children: [
      {
        path: 'job/new',
        canActivate: [
          () =>
            import('./guards/traveller-guest-job.guard').then(
              (m) => m.TravellerGuestJobGuard
            ),
        ],
        loadChildren: () =>
          import('@fleet/job/job-create/job-create.module').then(
            (m) => m.JobCreateModule
          ),
      },
      ...jobRoutes,
    ],
    canActivate: [TravellerAuthGuard],
  },
  {
    path: 'traveller',
    component: LayoutComponent,
    data: { layout: 'traveller' },
    resolve: {
      initialData: () =>
        import('./guards/initial-data-resolver-traveller.service').then(
          (m) => m.InitialDataResolverTravellerService
        ),
      traveller: () =>
        import('@fleet/traveller/traveller-resolve.guard').then(
          (m) => m.TravellerResolveGuard
        ),
    },
    canActivate: [TravellerAuthGuard],
    children: [
      {
        path: 'job/new',
        loadChildren: () =>
          import('@fleet/job/job-create/job-create.module').then(
            (m) => m.JobCreateModule
          ),
      },
      ...jobRoutes,
      {
        path: 'details-required',
        data: { layout: 'empty' },
        loadChildren: () =>
          import(
            '@fleet/traveller/traveller-details-required/traveller-details-required.module'
          ).then((m) => m.TravellerDetailsRequiredModule),
      },
    ],
  },
  {
    path: 'maintenance',
    loadChildren: () =>
      import('@fleet/maintenance').then((m) => m.ErrorFiveHundredModule),
  },
  {
    path: '**',
    loadChildren: () => import('@fleet/error').then((m) => m.Error404Module),
  },
];
